import React from "react";
import Navbar from "./Navbar";
import BottomNav from "./BottomNav";

// Shared shell for the app's two logged-in-style pages (Marketplace, Transaction
// History): top Navbar (nav links on desktop) plus a bottom tab bar on mobile.
const AdminLayout = ({ children, abc, xyz, bgClassName = "bg-black" }) => {
  return (
    <div className={`${bgClassName} min-h-screen flex flex-col`}>
      <Navbar abc={abc} xyz={xyz} />
      <div className="flex-1 pb-16 md:pb-0">{children}</div>
      <BottomNav abc={abc} xyz={xyz} />
    </div>
  );
};

export default AdminLayout;
